// lib
import {
  getAuthCookie,
  getRefreshTokenCookie,
  getAccessTokenCookie,
  getSignupTokenCookie,
} from './Storage';

// components
import Redirect from 'components/Redirect';

/**
 * @function withAuth
 * @summary auth hoc, use this with every page you want to protect. will redirect to auth page if user does not exists
 * @param {ComponentType<T>} Component
 */
function withAuth(Component) {
  return function WrappedWithAuth(props) {
    const auth = getAuthCookie();
    console.log('here!!!!');
    let redirectUrl = '/auth/otp'
    // eslint-disable-next-line no-restricted-globals
    if(location.host.startsWith("man"))
      redirectUrl =  '/auth'
    // return !!auth?.adminToken ? <Component {...props} /> : <Redirect to={'/auth'} />;
    return !!auth?.adminToken ||
      getRefreshTokenCookie() ||
      getAccessTokenCookie() ||
      getSignupTokenCookie() ? (
      <Component {...props} />
    ) : (
      <Redirect to={redirectUrl} />
    );
  };
}

export default withAuth;
